// extracted by mini-css-extract-plugin
module.exports = {"page":"ConsentsPage_page__GgOjY","title":"ConsentsPage_title__1qAjS"};